const runtimeEnv =
  typeof process !== 'undefined' && process.env
    ? process.env
    : ({} as Record<string, string>)

export const localConfig = {
  production: false,
  env: 'local',
  SERVER_ADDR: runtimeEnv.SERVER_ADDR || 'http://localhost/ems/',
  PIXELBOOKS_SERVER_ADDR:
    runtimeEnv.PIXELBOOKS_SERVER_ADDR || 'http://localhost/pixelbooks/',
  TRACK_SERVER_ADDR: runtimeEnv.TRACK_SERVER_ADDR || 'http://localhost/public/',
  ADMIN_SERVER_ADDR: runtimeEnv.ADMIN_SERVER_ADDR || 'http://localhost/admin/',
  ANALYTICS_SERVER_ADDR:
    runtimeEnv.ANALYTICS_SERVER_ADDR || 'http://localhost/analytics/',
  SUB_URI_V2: 'api/v2/',
  VERSION: '1.0.0.220115',
  TOOLBAR_COLOR: 'accent',
  SHOPIFY_FLOW: 'list',
  STRIPE_PUBLISHABLE_KEY:
    'pk_test_51NcENzH7ijxCcBHidvj0N4RirL6xw4R4xlXdYH8Ge0eDpbwW2KLR9HgHJKJ8GLdI0I0LXa30IhVqblGPkK9aVicg00RIJb8wi2',
  NEXT_PUBLIC_POS_INSTALLER_URL:
    'https://storage.googleapis.com/YOUR_BUCKET_NAME/downloads/PixelOne%20POS%20Setup%200.1.0.exe',
}
